<template>
  <div class="boxdivs" style="width: 100%; margin: auto">
    <div v-show="topdivdle" class="topdiv" @click="topdiv()">
      <img src="../image/iframe/topdiv.png" alt="" />
    </div>
    <div class="headerBox">
      <HeaDers />
    </div>
    <div class="boxdiv">
      <div class="block" style="width: 100%" :height="bannerHeight + 'vh'">
        <el-carousel
          :height="bannerHeight + 'vh'"
          arrow="always"
          indicator-position="none"
          v-if="bannerList.length && bannerList.length > 1"
        >
          <el-carousel-item v-for="(item, index) in bannerList" :key="index">
            <img :src="item.icon" alt="" />
          </el-carousel-item>
        </el-carousel>
        <el-carousel
          :height="bannerHeight + 'vh'"
          arrow="never"
          indicator-position="none"
          v-else
        >
          <el-carousel-item v-for="(item, index) in bannerList" :key="index">
            <img :src="item.icon" alt="" />
          </el-carousel-item>
        </el-carousel>

        <!-- <div class="loginSearch" v-if="booleanBtn">
          <span @click="toEnter">知识产权质量评价人员资质申请</span>
        </div> -->
        <div class="loginSearch" v-if="booleanBtnShow == 1 && showbtn">
          <span @click="toEnter">质量提升辅导人员信息采集</span>
        </div>
        <!-- <div v-if="booleanBtnShow == 1 && !showbtn" class="loginSearchF" @mouseleave="showExtraButtons = false">
          <div @mouseenter.stop="showExtraButtons = true" style="width: 250px;margin: 0 auto;">
            <el-button type="warning" style="width:220px;font-size: 20px;" round size="small">
              资质申请
            </el-button>
          </div>
          <div style="display: flex;justify-content: space-around;width:100%;margin-top:40px;"
            v-show="showExtraButtons">
            <el-button type="warning" style="width:280px;font-size: 20px;" round size="small"
              @click="handleCommand(62)">
              创新管理咨询师
            </el-button>
            <el-button type="warning" style="width:280px;font-size: 20px;" round size="small"
              @click="handleCommand(63)">
              创新管理实训主持人
            </el-button>
          </div>
          <div style="display: flex;justify-content: space-around;width:100%;margin-top:40px;"
            v-show="!showExtraButtons"></div>
        </div> -->

        <!-- <div class="loginSearch">
          <h2 style="line-height: 140px; height: 140px">
            知识产权质量评价人员信息采集
          </h2>
          <div class="btn">
            <el-button type="primary" @click="toEnter">进入采集</el-button>
          </div>
        </div> -->
      </div>
      <div style="background: #fff; width: 100%">
        <div
          class="newinformation"
          style="width: 1200px; margin: 0 auto 20px auto"
        >
          <h3>通知公告</h3>
          <div class="photoNew">
            <!-- v-if="noticeList.length" -->
            <div class="image">
              <img :src="notitePic" alt="" v-if="notitePic" loading="lazy" />
              <img src="../assets/notite.png" alt="" v-else />
            </div>
            <div class="title" v-show="noticeList.length">
              <div
                class="title-item"
                v-for="(item, index) in noticeList"
                :key="index"
                @click="moreLookDeail(item.id)"
                @mouseenter="changePic(item)"
                :title="item.notice_title"
              >
                <div style="display: flex; cursor: pointer; width: 82%">
                  <span
                    :class="{ blue: true, blueC: activeHover == item.id }"
                    >{{ index + 1 }}</span
                  >
                  <p
                    :class="activeHover == item.id ? 'blues' : ''"
                    style="width: 100%"
                  >
                    {{ item.notice_title }}
                  </p>
                </div>
                <span
                  :class="activeHover == item.id ? 'blues' : ''"
                  style="flex: none"
                  >{{ item.pub_time.slice(0, 10) }}</span
                >
              </div>
            </div>
            <div class="titles" v-show="!noticeList.length">
              <img src="../assets/noStatus.png" alt="" /><span>暂无公告</span>
            </div>
          </div>

          <div class="btn">
            <el-button
              type="primary"
              @click="moreLook"
              style="border-radius: 5px"
              >查看更多</el-button
            >
          </div>
        </div>
      </div>
      <div
        style="width: 100%; background: #fff; padding-bottom: 50px"
        class="bgNotice"
      >
        <div class="Service_display" style="width: 1200px; margin: auto">
          <h3>资质查询</h3>
          <div
            style="display: flex; flex-wrap: wrap; justify-content: flex-start"
          >
            <div
              class="cpfw"
              v-for="(item, index) in currentPageData"
              :key="index"
              @click="formInspection(item)"
            >
              <dl :title="item.value">
                <dt>
                  <img :src="item.icon" alt="" v-if="item.icon" />
                  <img src="../assets/personAll.png" alt="" v-else />
                </dt>
                <dd>
                  <p class="p_a">
                    {{ item.value }}
                  </p>
                </dd>
                <dd style="margin: 30px 0 10px 0">
                  <span class="button">查询服务</span>
                </dd>
              </dl>
            </div>
          </div>
          <el-pagination
            style="text-align: center; margin-top: 40px"
            @size-change="handleSizes"
            @current-change="handleCurrents"
            :current-page="currentPages"
            :page-size="pageSizes"
            layout="prev, pager, next"
            :total="totals"
          >
          </el-pagination>
          <!-- <Slider> -->

          <!-- </Slider> -->
          <!-- <div style="height: 100px"></div> -->
        </div>
      </div>
      <div style="width: 100%; background: #fff; padding-bottom: 50px">
        <div
          class="Service_display"
          style="width: 1200px; margin: auto; background: #fff"
        >
          <h3>资质列表</h3>
          <div>
            <el-tabs v-model="activeName" @tab-click="handleClick">
              <!-- <el-tab-pane label="创新管理咨询师" name="5"></el-tab-pane>
              <el-tab-pane label="创新管理实训主持人" name="6"></el-tab-pane> -->
              <el-tab-pane label="创新管理师" name="1"></el-tab-pane>
              <el-tab-pane label="分级评价人员" name="2"></el-tab-pane>
              <el-tab-pane label="质量提升辅导人员" name="3"></el-tab-pane>
              <el-tab-pane label="创新管理师2级" name="8"></el-tab-pane>
              <el-tab-pane label="创新管理实训" name="7"></el-tab-pane>
            </el-tabs>
            <div style="text-align: right">
              <el-input
                style="width: 300px"
                type="text"
                placeholder="请输入资质编号或者姓名搜索"
                size="small"
                @input="searchInput"
                v-model="value"
                clearable
              ></el-input>
            </div>
            <el-table
              :data="tableData"
              style="width: 100%; margin: 20px auto 0 auto"
              v-loading="loading"
            >
              <el-table-column
                prop="sn"
                label="序号"
                width="50"
                show-overflow-tooltip
                align="center"
              >
              </el-table-column>
              <el-table-column
                prop="cer_code"
                label="资质编号"
                width="250"
                show-overflow-tooltip
                align="center"
              >
              </el-table-column>
              <el-table-column
                prop="surname"
                label="姓名"
                width="200"
                show-overflow-tooltip
                align="center"
              >
                <template slot-scope="scope">
                  <span
                    style="cursor: pointer; color: #409eff"
                    @click="lookQuality(scope.row)"
                    >{{ scope.row.surname }}</span
                  >
                </template>
              </el-table-column>
              <!-- <el-table-column prop="email" label="邮箱" show-overflow-tooltip align="center"> </el-table-column> -->
              <el-table-column
                prop="province"
                label="工作地"
                width="200"
                show-overflow-tooltip
                align="center"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.province }}-{{ scope.row.city }}</span>
                </template></el-table-column
              >
              <el-table-column
                prop="unit_name"
                label="所属单位"
                show-overflow-tooltip
                align="center"
              >
              </el-table-column>
              <el-table-column
                prop="expiration_time"
                label="有效日期"
                show-overflow-tooltip
                align="center"
                width="150"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.expiration_time.slice(0, 10) }}</span>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination
              style="text-align: center; margin-top: 40px"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[5, 10, 20, 50]"
              :page-size="pageSize"
              layout="total,prev, pager, next, sizes,  jumper"
              :total="total"
            >
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
    <!-- 专利质量采集提示 -->
    <el-dialog
      :visible.sync="dialogVisibles"
      width="24%"
      top="30vh"
      :before-close="handleClose"
      :close-on-click-modal="false"
    >
      <div
        class="top"
        style="
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 10px 0;
        "
      >
        <img
          src="../assets/inforMation.png"
          alt=""
          style="margin-right: 5px; color: #000"
        /><span>温馨提示</span>
      </div>
      <span
        style="
          margin-left: 10px;
          margin-top: 20px;
          display: inline-block;
          color: #999999;
          white-space: pre-wrap;
        "
        v-html="messageTitle"
      ></span>
      <span slot="footer" class="dialog-footer" style="margin-left: 10px">
        <el-button type="primary" @click="dialogVisibles = false" round
          >我知道了</el-button
        >
      </span>
    </el-dialog>
    <!-- 资质查看 -->
    <el-dialog
      :visible.sync="dialogVisibleLook"
      width="50%"
      :show-close="false"
      :before-close="handleCloses"
      class="infoMation"
    >
      <div class="infomation">
        <div class="leftInfo">
          <p
            style="
              line-height: 50px;
              font-size: 23px;
              margin-bottom: 15px;
              font-weight: bold;
              color: rgb(74 101 179);
            "
          >
            {{ info.surname }}
          </p>
          <!-- <div>
            <h4>职&nbsp;&nbsp;&nbsp;&nbsp;称：</h4>
            {{info.post_title}}
          </div> -->
          <div>
            <h4>单&nbsp;&nbsp;&nbsp;&nbsp;位：</h4>
            {{ info.unit_name }}
          </div>
          <div>
            <h4>工作地：</h4>
            {{ info.province }}-{{ info.city }}-{{ info.county }}
          </div>
        </div>
        <div class="headPic" style="margin-right: 40px">
          <img
            v-if="info.photo_path"
            :src="info.photo_path"
            alt=""
            style="width: 127px; height: 170px"
          />
          <img
            v-else
            src="../assets/userpic.png"
            style="width: 127px; height: 170px"
          />
        </div>
      </div>
      <div class="content">
        <div class="header">个人简介</div>
        <div
          style="
            text-indent: 2em;
            padding: 10px 0;
            font-size: 15px;
            line-height: 30px;
          "
          v-if="info.introduction"
        >
          {{ info.introduction }}
        </div>
        <div
          style="
            text-indent: 2em;
            padding: 10px 0;
            font-size: 15px;
            line-height: 30px;
          "
          v-else
        >
          暂无
        </div>
      </div>
      <div class="content">
        <div class="header">单位简介</div>
        <div
          style="
            text-indent: 2em;
            padding: 10px 0;
            font-size: 15px;
            line-height: 30px;
          "
          v-if="info.unitIntroduction"
        >
          {{ info.unitIntroduction }}
        </div>
        <div
          style="
            text-indent: 2em;
            padding: 10px 0;
            font-size: 15px;
            line-height: 30px;
          "
          v-else
        >
          暂无
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          @click="dialogVisibleLook = false"
          plain
          size="small"
          >关闭</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      :visible.sync="dialogVisibleFlag"
      width="24%"
      top="30vh"
      :show-close="false"
      :before-close="handleCloseflag"
      :close-on-click-modal="false"
    >
      <div
        class="top"
        style="
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 10px 0;
        "
      >
        <img
          src="../assets/inforMation.png"
          alt=""
          style="margin-right: 5px; color: #000"
        /><span>温馨提示</span>
      </div>
      <span
        style="
          margin-left: 10px;
          margin-top: 20px;
          display: inline-block;
          color: #999999;
          white-space: pre-wrap;
        "
        >{{ msgInfo }}</span
      >
      <span slot="footer" class="dialog-footer" style="margin-left: 10px">
        <el-button
          type="primary"
          @click="dialogVisibleFlag = false"
          size="small"
          >我知道了</el-button
        >
      </span>
    </el-dialog>
    <Foot />

    <!-- ✅ 新增：强制修改密码弹窗（密码已过期/即将过期时弹出，不可关闭） -->
    <el-dialog
      title="密码修改"
      :visible.sync="forcePwdDialogVisible"
      width="480px"
      top="15vh"
      :close-on-click-modal="forceExpireFlag !== '0'"
      :show-close="forceExpireFlag !== '0'"
      :before-close="forceExpireFlag === '0' ? () => {} : null"
    >
      <div
        style="
          margin-bottom: 15px;
          color: #e6a23c;
          font-size: 14px;
          line-height: 1.6;
        "
      >
        <i class="el-icon-warning-outline" style="margin-right: 5px"></i>
        {{
          forceExpireFlag === "0"
            ? "您的密码已过期，请立即修改密码后继续使用！"
            : "您的密码即将过期，为保障账户安全，请尽快修改密码！"
        }}
      </div>
      <el-form
        ref="forcePwdForm"
        :model="forcePwdForm"
        :rules="forcePwdRules"
        label-width="100px"
        label-position="right"
      >
        <el-form-item label="新密码" prop="newPassword">
          <el-input
            v-model="forcePwdForm.newPassword"
            type="password"
            auto-complete="off"
            placeholder="请输入新密码（8-16位，含大小写字母、数字及特殊符号）"
            show-password
          ></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="confirmPassword">
          <el-input
            v-model="forcePwdForm.confirmPassword"
            type="password"
            auto-complete="off"
            placeholder="请再次输入新密码"
            show-password
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" style="text-align: center">
        <el-button
          type="primary"
          :loading="forcePwdLoading"
          @click="submitForcePwd"
        >
          确认修改
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import HeaDers from "../components/HeaDers.vue";
import Foot from "../components/Foot.vue";
import Slider from "../components/slide.vue";
import {
  getHomeNoticeList,
  getDictInfoNews,
  getAreaTime,
  homePages,
  preCheck,
  updatePasswd, // ✅ 新增
} from "@/api/api.js";
import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
export default {
  components: { HeaDers, Foot, Slider },
  data() {
    return {
      showExtraButtons: false,
      tabPosition: "right",
      screenWidth: document.body.clientWidth,
      array: [],
      bannerHeight: "48",
      topdivdle: false,
      timer: false,
      loginshow: true,
      noticeList: [],
      dialogVisibles: false,
      dialogVisibleLook: false,
      booleanBtn: null,
      booleanBtnShow: 0,
      messageTitle: "",
      arrayText: [],
      notitePic: "",
      activeName: "1",
      tableData: [],
      value: "",
      pageSize: 5,
      currentPage: 1,
      total: 0,
      info: {},
      dialogVisibleFlag: false,
      msgInfo: "",
      activeindex: "",
      showbtn: false,
      loading: false,
      activeHover: "",
      // totals:0,
      pageSizes: 10,
      currentPages: 1,
      currentPageData: [],
      bannerList: [{ icon: require("../assets/banner_second.png") }],

      // ✅ 新增：强制修改密码相关字段
      forcePwdDialogVisible: false,
      forceExpireFlag: "",
      forcePwdLoading: false,
      forcePwdForm: {
        newPassword: "",
        confirmPassword: "",
      },
      forcePwdRules: {
        newPassword: [
          { required: true, message: "请输入新密码", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              if (!value) {
                callback();
              } else {
                // 8-16位，必须包含大小写字母、数字、特殊符号
                let reg =
                  /^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[@$!%*?&#:;,._])[a-zA-Z\d@$!%*?&#:;,._]{8,16}$/;
                if (reg.test(value)) {
                  callback();
                } else {
                  callback(
                    new Error(
                      "请输入8-16位同时包含大小写字母、数字及特殊符号的组合"
                    )
                  );
                }
              }
            },
            trigger: ["blur", "change"],
          },
        ],
        confirmPassword: [
          { required: true, message: "请再次输入新密码", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              if (value !== this.forcePwdForm.newPassword) {
                callback(new Error("两次输入的密码不一致"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
      },
    };
  },

  watch: {
    // bannerHeight(val) {
    //   // 为了避免频繁触发resize函数导致页面卡顿，使用定时器
    //   if (!this.timer) {
    //     // 一旦监听到的screenWidth值改变，就将其重新赋给data里的screenWidth
    //     this.bannerHeight = val;
    //     this.timer = true;
    //     let that = this;
    //     setTimeout(function () {
    //       // 打印screenWidth变化的值
    //       console.log(that.bannerHeight);
    //       that.timer = false;
    //     }, 400);
    //   }
    // },
    "navigator.userAgent"(val) {
      console.log(val);
    },
  },
  computed: {
    totals() {
      return this.arrayText.length; // 总数据量
    },
  },
  created() {
    this.$store.state.indexActive = 51;
    getDictInfoNews("BANNER").then((res) => {
      if (res.code == 1000) {
        if (!res.data.length) return;
        this.bannerList = res.data;
      }
    });
  },
  mounted() {
    getAreaTime().then((response) => {
      if (response.code == 1000) {
        // this.booleanBtn = response.data.boolean;
        this.booleanBtnShow = 1;
        this.showbtn = response.data.show;
      }
    });
    this.handleScroll();
    this.gethomePages();
    this.gethomePage();
    var value = sessionStorage.getItem("user");
    if (value != "" && value != undefined) {
      this.loginshow = false;
    } else {
      this.loginshow = true;
    }

    if (this.$route.query.id == "111") {
      this.toEnter();
      // this.$route.query.id = ''
    }
    getDictInfoNews("ZZLXS").then((res) => {
      if (res.code == 1000) {
        this.arrayText = res.data;
        this.updatePageData();
      }
    });

    // ✅ 新增：检测登录时返回的密码过期标识，强制弹窗修改密码
    const forceFlag = sessionStorage.getItem("forceChangePwd");
    if (forceFlag === "0") {
      // 已过期 → 强制弹窗，不可关闭
      this.forceExpireFlag = "0";
      this.forcePwdDialogVisible = true;
    } else if (forceFlag === "1") {
       // 即将过期：仅轻提示（不弹窗，下次登录还会再提醒）
      this.$message.warning("您的密码即将过期，为保障账户安全，请尽快在【个人中心】修改密码！");
      sessionStorage.removeItem("forceChangePwd");
    }
    // 没有标记 → 什么都不弹，正常显示 ✅
  },
  methods: {
    // 资质查询
    handleSizes(val) {
      this.pageSizes = val;
      this.updatePageData();
    },
    //资质查询
    handleCurrents(val) {
      this.currentPages = val;
      this.updatePageData();
    },
    // 获取当前页数据
    updatePageData() {
      const start = (this.currentPages - 1) * this.pageSizes;
      const end = start + this.pageSizes;
      this.currentPageData = this.arrayText.slice(start, end);
    },
    // 通知公告
    gethomePage() {
      let page = {
        size: "5",
        page: "1",
      };
      getHomeNoticeList(page).then((res) => {
        if (res.code == 1000) {
          if (!res.data.list) return;
          this.notitePic = res.data.list[0].notice_pic_path;
          if (res.data.list[0].notice_pic_path) {
            this.activeHover = res.data.list[0].id;
          }

          this.noticeList = res.data.list;
          if (this.noticeList.length > 5) {
            let arr = this.noticeList;
            this.noticeList = arr.slice(0, 5);
          }
        }
      });
    },
    // 公告移入某一条 左侧图片切换为维护的图片
    changePic(item) {
      // console.log(item)
      this.notitePic = item.notice_pic_path;
      this.activeHover = item.id;
    },
    // 资质查询搜索
    searchInput() {
      this.currentPage = 1;
      this.gethomePages();
    },
    // 资质申请 咨询师和 游戏主持人
    handleCommand(command) {
      sessionStorage.removeItem("index");
      this.activeindex = command;
      this.$store.state.indexActive = command;
      var value = sessionStorage.getItem("user");
      // 这里可以根据 command 的值来执行不同的操作
      if (command == 62) {
        if (value != "" && value != undefined) {
          this.getFlag();
        } else {
          sessionStorage.removeItem("index");
          this.$router.push({ name: "Signin" });
        }
      } else if (command == 63) {
        if (value != "" && value != undefined) {
          this.getFlag();
        } else {
          sessionStorage.removeItem("index");
          this.$router.push({ name: "Signin" });
        }
      }
    },
    // 判断状态等-是否可以进行采集
    getFlag() {
      if (this.activeindex == 62) {
        // 咨询师
        preCheck(this.$qs.stringify({ userType: "1", cerType: "5" })).then(
          (res) => {
            this.msgInfo = res.msg;
            if (res.code != "1000" && !res.data) {
              this.dialogVisibleFlag = true;
            } else {
              if (res.data) {
                let data = res.data;
                this.$router.push({
                  name: "consultant",
                  query: {
                    id: this.activeindex,
                    userInfos: data.id,
                    operStep: data.operStep,
                  },
                });
              } else {
                this.$router.push({
                  name: "consultant",
                  query: { id: this.activeindex },
                });
              }
            }
          }
        );
      } else if (this.activeindex == 63) {
        preCheck(this.$qs.stringify({ userType: "2", cerType: "6" })).then(
          (res) => {
            this.msgInfo = res.msg;
            if (res.code != "1000" && !res.data) {
              this.dialogVisibleFlag = true;
            } else {
              if (res.data) {
                let data = res.data;
                this.$router.push({
                  name: "gameMaster",
                  query: {
                    id: this.activeindex,
                    userInfos: data.id,
                    operStep: data.operStep,
                  },
                });
              } else {
                this.$router.push({
                  name: "gameMaster",
                  query: {
                    id: this.activeindex,
                  },
                });
              }
            }
          }
        );
      }
    },
    isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
    // 资质列表-查询数据
    gethomePages() {
      let data = {
        pageSize: this.pageSize,
        pageNum: this.currentPage,
        value: this.value,
        cerType: this.activeName,
      };
      this.loading = true;
      homePages(this.$qs.stringify(data)).then((res) => {
        if (res.code == "1000") {
          this.loading = false;
          this.tableData = res.data.list;
          this.total = res.data.total;
        }
      });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.gethomePages();
    },
    //分页 -- 当前页数
    handleCurrentChange(val) {
      this.currentPage = val;
      this.gethomePages();
    },

    handleClose() {
      this.dialogVisibles = false;
    },
    handleCloses() {
      this.dialogVisibleLook = false;
    },
    handleCloseflag() {
      this.dialogVisibleFlag = false;
    },
    lookQuality(row) {
      console.log(row);
      this.dialogVisibleLook = true;
      this.info = row;
    },
    moreLook() {
      this.$router.push({ name: "Rotation" });
      this.$store.state.indexActive = 57;
      sessionStorage.setItem("index", 57);
    },
    moreLookDeail(id) {
      this.$router.push({
        name: "Rotation",
        params: {
          id: id,
        },
      });
      this.$store.state.indexActive = 57;
      sessionStorage.setItem("index", 57);
      // sessionStorage.removeItem('index')
    },
    toEnter() {
      // getDictInfoNew("CJJZSJ").then((res) => {
      //   console.log(res);
      //   let data = {
      //     type: res.data[0].code,
      //   };
      getAreaTime().then((response) => {
        if (response.code == 1000) {
          if (response.data.boolean == false) {
            this.dialogVisibles = true;
            this.messageTitle = response.data.resultMsg;
          } else {
            this.$router.push({ name: "Enterpriseinformations" });
            this.$store.state.indexActive = 64;
            sessionStorage.setItem("index", 64);
          }
        }
      });
    },
    formInspection(row) {
      var value = sessionStorage.getItem("user");
      if (value != "" && value != undefined) {
        this.$router.push({
          name: "Inspection",
          query: { name: row.value, type: row.code },
        });
        this.$store.state.indexActive = row.code;
        sessionStorage.setItem("index", row.code);
      } else {
        sessionStorage.removeItem("index");
        this.$router.push({ name: "Signin" });
      }
    },
    handleScroll() {
      this.$nextTick(() => {
        var top =
          document.body.scrollTop ||
          document.documentElement.scrollTop ||
          window.pageYOffset;
        if (top > 2200) {
          this.topdivdle = true;
        } else if (top <= 2200) {
          this.topdivdle = false;
        }
      });
    },
    center() {
      this.$router.push({ name: "user", query: { id: "1" } });
    },
    topdiv() {
      window.scrollTo(0, 0);
    },
    signup() {
      var value = sessionStorage.getItem("user");
      if (value != "" && value != undefined) {
        // let details = JSON.stringify(item);
        // sessionStorage.setItem("details", details); // 存入一个值
        // this.$router.push({
        //   name: "signup",
        // });
        this.loginshow = false;
      } else {
        this.$router.push({ name: "Signin" });
      }
    },
    register() {
      this.$router.push({ name: "register" });
    },
    handleClick() {
      this.currentPage = 1;
      this.gethomePages();
    },

    // ✅ 新增：强制修改密码提交
    submitForcePwd() {
      this.$refs.forcePwdForm.validate((valid) => {
        if (!valid) return;
        this.forcePwdLoading = true;
        // 与登录一致的 Base64 两次加密
        const encNew = this.$Base64.encode(this.forcePwdForm.newPassword);
        const encNew2 = this.$Base64.encode(encNew);
        let fd = new FormData();
        fd.append("password", encNew2);
        updatePasswd(fd)
          .then((res) => {
            this.forcePwdLoading = false;
            if (res.code == 1000) {
              this.$message.success("密码修改成功！");
              // 清除标记，关闭弹窗，清空表单
              sessionStorage.removeItem("forceChangePwd");
              this.forcePwdDialogVisible = false;
              this.forcePwdForm = { newPassword: "", confirmPassword: "" };
              this.$refs.forcePwdForm && this.$refs.forcePwdForm.resetFields();
            } else {
              this.$message.error(res.msg || "密码修改失败，请重试");
            }
          })
          .catch(() => {
            this.forcePwdLoading = false;
            this.$message.error("网络异常，请稍后重试");
          });
      });
    },
  },
};
</script>

<style scoped lang="less">
::v-deep .el-dialog {
  border-radius: 5px;
}

::v-deep .el-dialog__footer {
  text-align: center;
}

::v-deep .el-dialog__header {
  padding-top: 15px;
}

::v-deep .el-dialog__body {
  text-align: center;
  font-size: 16px;
  padding: 0 20px 20px 20px;
}

h3 {
  line-height: 100px;
  height: 100px;
  font-size: 28px;
  text-align: center;
}

.Service_display {
  // display: flex;
  // justify-content: space-between;
  .btn-box {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  width: 1200px;
  display: flex;

  flex-direction: column;

  .dsip {
    margin-top: 50px;
    display: flex;
    justify-content: center;
  }

  ul {
    // margin-top: 40px;
    display: flex;
    justify-content: center;
    justify-content: space-between;
    flex-wrap: wrap;

    li {
      background: #fff;
      border-radius: 5px;
      display: flex;
      width: 260px;
      justify-content: center;

      dl {
        margin-top: 20px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        dt {
          height: 120px;
          width: 120px;
          border-radius: 50%;

          img {
            height: 100%;
            width: 100%;
          }
        }

        dd {
          margin-top: 8px;
          // border-top: 1px solid #4294f7;

          // width: 180px;
          position: relative;

          //  display: flex;
          //  flex-direction: column-reverse;
          h3 {
            margin-top: 25px;
          }

          .location {
            // position: absolute;
            // bottom: 0;
            // right: 0;
            display: flex;
            justify-content: right;
            color: rgba(22, 155, 213);
            cursor: pointer;
            margin-bottom: 10px;
          }

          p {
            padding-top: 20px;

            overflow: hidden; //超出文本隐藏

            text-overflow: ellipsis; ///超出部分省略号显示

            display: -webkit-box; //弹性盒模型

            display: -webkit-box;

            word-break: break-all;

            -webkit-box-orient: vertical; //上下垂直

            -webkit-line-clamp: 2; //自定义行数
            display: left;
            text-align: left;
            text-align: center;
          }
        }
      }
    }
  }
}

.bgNotice {
  width: 100%;
  background: url("../assets/notiteBanner.png") no-repeat !important;
  background-size: 100% 100%;
}

.bgNotice {
  width: 100%;
  background: url("../assets/notiteBanner.png") no-repeat !important;
  background-size: 100% 100%;
}

.newinformation {
  width: 100%;
  // height: 100%;
  // background: url("../assets/notiteBanner.png") 100%;
  background-size: 100% 100%;
  // margin-bottom: 20px;

  .photoNew {
    display: flex;
    justify-content: space-between;

    .image {
      width: 500px;
      height: 280px;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .title {
      width: 700px;
      text-align: left;
      margin-left: 20px;
      display: flex;
      flex-direction: column;

      // justify-content: space-between;
      .title-item {
        width: 100%;
        font-size: 16px;
        height: 20%;
        padding: 10px 0;
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-wrap: nowrap;
        margin-bottom: 10px;
        padding-right: 10px;
        padding-left: 10px;
        box-sizing: border-box;
        color: #333;
        background: #eef0fa;

        p {
          overflow: hidden;
          text-align: left;
          // width: 450px;
          white-space: nowrap;
          text-overflow: ellipsis;
        }

        .time {
          width: 100px;
          display: inline-block;
        }

        .blue {
          background: #b1b0b0;
          color: #fff;
          border-radius: 5px;
          padding: 0 8px;
          text-align: center;
          display: block;
          margin-right: 10px;
        }

        .blueC {
          background: #287fea;
          color: #fff;
        }

        .blues {
          color: #287fea;
        }

        // }
      }

      // .title-item:hover {
      //   // background: #eef0fa;
      //   // opacity: 0.3;
      //   color: #000;

      // }

      .title-item:last-child {
        margin-bottom: 0;
      }
    }
  }

  .titles {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    flex: 1;

    img {
      width: 180px;
      height: 180px;
    }

    span {
      display: inline-block;
      width: 200px;
      text-align: center;
      line-height: 40px;
      font-size: 18px;
      margin-left: 5px;
    }
  }

  .el-button {
    padding: 15px 50px;
    background: #607fea;
    border: 1px solid #607fea;
    border-radius: 30px;
  }

  .btn {
    margin-top: 40px;
    margin-bottom: 50px;
    text-align: center;
  }
}

.boxdiv {
  /* font-family:"\5FAE\8F6F\96C5\9ED1";
  */
  font-family: Microsoft YaHei;
  /* font-family: "Helvetica Neue", Helvetica, Arial, "PingFang SC", "Hiragino Sans GB", "Heiti SC", "Microsoft YaHei", "WenQuanYi Micro Hei", sans-serif; */
  // margin-bottom: 14px !important;
  font-size: 17px;
  font-style: normal;
  font-weight: 400;
  line-height: 26px;
  letter-spacing: 1px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 80px;
}

.block {
  position: relative;
}

.loginSearchF {
  position: absolute;
  z-index: 9;
  bottom: 8%;
  left: 50%;
  width: 800px;
  margin-left: -400px;
  font-size: 28px;
  cursor: pointer;
  // margin-left: -25%;
  text-align: center;
  // display: flex;
  // justify-content: center;
  color: #fff;
}

.loginSearch {
  position: absolute;
  z-index: 9;
  bottom: 19%;
  left: 50%;
  width: 500px;
  margin-left: -250px;
  font-size: 28px;
  cursor: pointer;
  // margin-left: -25%;
  text-align: center;
  display: flex;
  justify-content: center;
  color: #fff;
  //

  h2 {
    line-height: 50px;
    font-size: 40px;
  }

  p {
    // line-height: 50px;
    margin: 30px 0;
    font-size: 20px;
    color: #000;
  }

  span {
    display: inline-block;
    width: 100%;
    height: 100%;
    background: #eca012;
    padding: 12px 0px;
    border-radius: 30px;
    letter-spacing: 2px;
  }

  .btn {
  }

  // .el-button {
  //   padding: 15px 60px;
  //   font-size: 15px;

  //   ::v-deep.el-button--primary {
  //     background: #607fea;
  //     border: 1px solid #607fea;
  //   }
  // }

  // .btn{
  //   text-align: center;
  // }
  // top: ;
}

.el-carousel__item h3 {
  color: #475669;
  font-size: 18px;
  opacity: 0.75;
  line-height: 500px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}

.el-carousel__item img {
  width: 100%;
  height: 100%;
}

.boxa {
  width: 100%;
  //  height: 500px;
  margin: auto;
  min-height: 400px;
}

.boxa /deep/.el-carousel__container {
  min-height: 400px;

  width: 100%;

  img {
    width: 100%;
    height: 100%;
  }
}

.bannerImg {
  width: 100%;

  height: inherit;

  min-height: 360px;

  min-width: 1400px;
}

.hover:hover {
  box-shadow: 0px 0px 5px rgb(0, 150, 255);
  /* 边框阴影 */
  -moz-box-shadow: 0px 0px 5px #888888;
  /* 老的 Firefox */
  border-top: 5px rgb(0, 150, 255) solid;
}

.cpfw {
  width: 19%;
  margin-right: 12px;
  flex: none;
  border-radius: 10px;
  // width: 555px;
  padding: 20px 5px;
  margin-bottom: 20px;
  // margin-right: 20px;
  box-sizing: border-box;
  float: left;
  // margin-left: 30px;
  // margin-bottom: 30px;
  box-shadow: 2px 3px 10px 2px rgba(0, 0, 0, 0.1);
  transition-duration: 0.1s;
  transition-timing-function: linear;
  transition-delay: 0s;
  transition-property: all;
  cursor: pointer;
  text-align: center;

  dl {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;

    dt {
      // margin-top: -20px;
      width: 90px;
      height: 90px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-end;
      padding-bottom: 20px;

      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }
  }
  dd {
    width: 100%;
  }
  .button {
    width: 70%;
    text-align: center;
    padding: 10px 30px;
    border-radius: 5px;
    border: 1px solid #607fea;
    color: #607fea;
    font-size: 14px;
  }
}

.cpfw:last-child {
  margin-right: 0;
}

.cpfw:hover {
  transform: scale(1.02);
  // box-shadow: 2px 2px 10px 2px rgb(162, 207, 251);
}

.p_a {
  position: relative;
  line-height: 20px;
  max-height: 40px;
  width: 99%;
  color: #000;
  font-size: 20px;
  overflow: hidden;
  text-align: center;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.p_a::after {
  position: absolute;
  bottom: 0;
  right: 0;
  padding-left: 40px;

  background: -webkit-linear-gradient(left, transparent, #fff 55%);

  background: -o-linear-gradient(right, transparent, #fff 55%);

  background: -moz-linear-gradient(right, transparent, #fff 55%);

  background: linear-gradient(to right, transparent, #fff 55%);
}

.topdiv {
  position: fixed;
  right: 100px;
  bottom: 100px;
  height: 100px;
  width: 100px;
  z-index: 20;

  img {
    cursor: pointer;
    height: 100%;
    width: 100%;
  }
}

/deep/.el-table th.el-table__cell {
  background: #f5f7fa;
  color: #000;
}

//
.infomation {
  display: flex;
  // align-items: center;
  justify-content: space-between;
  padding: 5px 40px 20px 40px;
  color: #000;
  font-size: 15px;
}

.leftInfo {
  text-align: left;
}

.leftInfo > div {
  display: flex;
  align-items: center;
  line-height: 30px;
}

.content {
  text-align: left;
  padding: 0 40px;
  color: #000;
}

.header {
  background: #e5e9ed;
  color: #56647a;
  line-height: 38px;
  padding-left: 10px;
  font-weight: bold;
  font-size: 16px;
}

/deep/ .el-tabs__item {
  font-size: 18px;
}
</style>